import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import * as Sentry from '@sentry/react-native';

/** Axios: sem `response` é rede; com `response.status >= 500` é a API caindo. */
function isNetworkOrServerError(error: unknown): boolean {
  const err = error as
    | { response?: { status?: number }; isAxiosError?: boolean }
    | null
    | undefined;
  if (!err) return false;
  if (err.isAxiosError && !err.response) return true;
  return typeof err.response?.status === 'number' && err.response.status >= 500;
}

/** Chamado só depois que o retry (1x) já esgotou — onError do cache dispara uma vez por falha final. */
function reportQueryError(key: unknown, error: unknown): void {
  Sentry.addBreadcrumb({
    category: 'react-query',
    message: String(key),
    level: 'error',
  });

  if (isNetworkOrServerError(error)) {
    Sentry.captureException(error);
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => reportQueryError(query.queryKey[0], error),
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) =>
      reportQueryError(mutation.options.mutationKey?.[0], error),
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      retry: 1,
    },
  },
});
